import React, { useState } from "react";
import { FiNavigation } from "react-icons/fi";
import "./CenterToLastKnownLocationButton.scss"; // Import the SCSS

export const CenterToLastKnownLocationButton = ({ mapRef, position }) => {
  const [isScaling, setIsScaling] = useState(false);

  const handleCenterMap = () => {
    if (position && mapRef.current) {
      mapRef.current.setView(position, mapRef.current.getZoom());
    }

    // Trigger the scale animation
    setIsScaling(true);
    setTimeout(() => setIsScaling(false), 300); // Reset after animation
  };

  return (
    <button onClick={handleCenterMap} className="center-button-laastknown-location">
      <FiNavigation
        className={`icon ${isScaling ? "scale-up" : "scale-down"}`}
      />
    </button>
  );
};
